"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable no-plusplus */
/* eslint-disable prettier/prettier */
/* eslint-disable prefer-destructuring */
/* eslint-disable no-param-reassign */
const react_1 = __importDefault(require("react"));
const link_1 = __importDefault(require("next/link"));
const prop_types_1 = __importDefault(require("prop-types"));
const utils_1 = require("./utils");
const currentEnv = `${process.env.NEXT_PUBLIC_ENV_NAME}`;
const appendHost = (href) => {
    if (href.indexOf('http') === -1 && href.indexOf('//') === -1) {
        switch (currentEnv) {
            case 'dev':
                href = `127.0.0.1:8089${href}`;
                break;
            case 'prod':
                href = `https://www.movistar.es${href}`;
                break;
            case 'qa':
                href = `https://qa.cms.col.movistar.es${href}`;
                break;
        }
    }
    return href;
};
const getReadyLinkForDev = (href) => {
    // eliminamos el basename del proyecto
    let devLink = href.replace(`${process.env.NEXT_PUBLIC_PROJECT_BASE_PATH}`, '');
    if (!devLink) {
        devLink = "/";
    }
    return devLink;
};
const checkIfHasHrefOperators = (href) => {
    let result = false;
    const OPERATORS = ['tel:', 'mailto:'];
    OPERATORS.forEach(item => {
        if (!result && href.indexOf(item) > -1) {
            result = true;
        }
    });
    return result;
};
/**
 * @name NextLink
 * @description atomic component
 * @see {@link https://nextjs.org/docs/api-reference/next/link}
 * @param {LinkProps} props
 * @param {React.Ref} ref
 * @returns {React.FC}
 */
const NextLink = ({ id, children, className, internal, href, taggingInfo, title: cmpTitle, target, ariaLabel: cmpAriaLabel, screenReadable: cmpScreenRedable, style, onClick, buttonParent, buttonTypeHtml, nextLinkProps, disabled, custoObjectInfo, cyData, }) => {
    let currentClassName = `next-link${className ? ` ${className}` : ''}`;
    const finalCssName = !children
        ? `${currentClassName} nextLinkOverBox`
        : currentClassName;
    const { title, ariaLabel, ariaHidden } = (0, utils_1.extendsAccesibility)({
        cmpTitle,
        cmpAriaLabel,
        cmpScreenRedable,
        taggingInfo,
    });
    /* wrapeamos funciones ejecutadoras */
    const { newOnClick: onClickHandler, newOnKeyDown: onKeyDownHandler, newOnMouseDown: onMouseDownHandler, } = (0, utils_1.generateOnHandlerMethods)({
        onClick,
        taggingInfo,
        disabled,
    });
    // personalizo
    let editModal = null;
    if (custoObjectInfo) {
        editModal = () => {
            custoObjectInfo.handler(custoObjectInfo.entryPoint);
        };
        currentClassName = `${currentClassName} custo-editable`;
        if (children) {
            return (react_1.default.createElement("div", { className: currentClassName, onClick: editModal }, children));
        }
        return (react_1.default.createElement("div", { className: currentClassName, onClick: editModal }, "Enlace"));
    }
    // 0) vemos si tiene href sino tiene solo es un elemento para taggear (TODO)
    if (!href && onClick) {
        return (react_1.default.createElement("button", { id: id || null, type: buttonTypeHtml, className: finalCssName, tabIndex: 0, "aria-label": ariaLabel, "aria-hidden": ariaHidden, title: title, onClick: onClickHandler, onKeyDown: onKeyDownHandler, onMouseDown: onMouseDownHandler, disabled: disabled, style: style, "data-cy": cyData },
            buttonParent && (react_1.default.createElement("div", { className: "hover-layer" })),
            children));
    }
    const hasOperators = checkIfHasHrefOperators(href);
    // "2 ) logica de link as usual"
    if (!internal && currentEnv === 'dev' && !hasOperators) {
        href = getReadyLinkForDev(href);
    }
    if (!internal && currentEnv !== 'dev' && !hasOperators) {
        href = appendHost(href);
    }
    if (!internal) {
        return (react_1.default.createElement("a", { id: id || null, className: finalCssName, tabIndex: 0, "aria-label": ariaLabel, "aria-hidden": ariaHidden, title: title, href: href, target: target, rel: target === '_blank' ? 'noopener noreferrer' : '', onClick: onClickHandler, onKeyDown: onKeyDownHandler, onMouseDown: onMouseDownHandler, disabled: disabled, style: style, "data-cy": cyData },
            buttonParent && (react_1.default.createElement("div", { className: "hover-layer" })),
            children));
    }
    /* Para enlaces en relativo que se consideren internos a la app */
    const { as, prefetch, replace, scroll, shallow, locale } = nextLinkProps;
    return (react_1.default.createElement(link_1.default, { href: href, as: as, passHref: true, replace: replace, scroll: scroll, shallow: shallow, locale: locale, className: finalCssName, tabIndex: 0, "aria-label": ariaLabel, "aria-hidden": ariaHidden, title: title, target: target, rel: target === '_blank' ? 'noopener noreferrer' : '', onClick: onClickHandler, onKeyDown: onKeyDownHandler, style: style, onMouseDown: onMouseDownHandler, "data-cy": cyData },
        buttonParent && (react_1.default.createElement("div", { className: "hover-layer" })),
        children));
};
NextLink.propTypes = {
    /**
     * Id del componente.
     */
    id: prop_types_1.default.string,
    /**
     * Enlace al que se quiere redireccionar.
     */
    href: prop_types_1.default.oneOfType([prop_types_1.default.string, prop_types_1.default.object]),
    /**
     * Función que se quiere ejecutar al clickar el componente.
     */
    onClick: prop_types_1.default.func,
    /**
     * Clase para estilos adicionales.
     */
    className: prop_types_1.default.string,
    /**
     * Información para el tagueado del componente.
     */
    taggingInfo: prop_types_1.default.object.isRequired,
    /**
     * Comportamiento para cuando se utiliza href, por defecto
     * es _self pero se puede cambiar a _blank si se quiere que
     * el enlace se abra en una nueva pestaña.
     */
    target: prop_types_1.default.string,
    /**
     * Texto que se muestra al pasar el ratón por encima del componente.
     *  Primero utiliza taggingInfo.componentContent y si es nulo utiliza este atributo.
     */
    title: prop_types_1.default.string,
    /**
     * Proporciona una descripción
     * precisa y concisa del contenido del elemento para usuarios de
     * tecnologías de asistencia, como lectores de pantalla, que
     * no pueden ver o interpretar el contenido visual.
     * Primero utiliza taggingInfo.componentContent y si es nulo utiliza este atributo.
     */
    ariaLabel: prop_types_1.default.string,
    /**
     * Deshabilita el componente (solo en ocasiones que se utiliza onClick).
     */
    disabled: prop_types_1.default.bool,
    /**
     *  Cuando se establece en true, indica que el elemento no debe ser presentado visualmente o leído por el lector de pantalla.
     */
    screenReadable: prop_types_1.default.bool,
    /**
     * Distintas propiedades para enlaces en relativo que se consideren internos a la app.
     */
    nextLinkProps: prop_types_1.default.shape({
        passHref: prop_types_1.default.bool,
        replace: prop_types_1.default.bool,
        as: prop_types_1.default.oneOfType([prop_types_1.default.string, prop_types_1.default.object]),
        scroll: prop_types_1.default.bool,
        shallow: prop_types_1.default.bool,
        locale: prop_types_1.default.oneOfType([prop_types_1.default.string, prop_types_1.default.bool]),
    }),
    /**
     * Establece el tipo de elemento cuando usamos onClick.
     */
    buttonTypeHtml: prop_types_1.default.string,
    /**
     * Parámetros para componente button (ignorar).
     */
    buttonParent: prop_types_1.default.bool,
    /**
     * Parámetros para componente button (ignorar).
     */
    style: prop_types_1.default.object,
    cyData: prop_types_1.default.string,
    internal: prop_types_1.default.bool,
};
NextLink.defaultProps = {
    id: null,
    className: "",
    target: "_self",
    screenReadable: true,
    nextLinkProps: {
        passHref: true,
        as: null,
        replace: false,
        scroll: true,
        shallow: true,
        locale: "",
    },
    disabled: false,
    onClick: null,
    buttonTypeHtml: "button",
    buttonParent: false,
    style: {},
    cyData: '',
    internal: false,
};
exports.default = NextLink;
//# sourceMappingURL=index.js.map